module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.e5c71208ed98568d.js");
}
